//#region Enums

export enum EnumIdsTcTipoSolicitud {
    ID_NORMAL = 1,
    ID_TRASLADO = 2, //Antes ID_TRANSITO
    ID_FINES_CIENTIFICOS = 3,
    ID_ORG_CONTROL_BIOLOGICO = 4,
    ID_CANARIAS = 5,
    ID_TRANSITO_DIRECTO = 6,
    ID_PASAJEROS = 7,
    ID_TRANSBORDO = 8,
    ID_PROD_FITOSANITARIOS = 9,
}

export enum EnumCodigosTcTipoSolicitud {
    NORMAL = 'N',
    CANARIAS = 'C',
    PRODUCTOS_FITOSANITARIOS = 'PF',
    TRASLADO = 'T',
    TRANSITO_DIRECTO = 'TD',
    TRANSBORDO = 'TB',
    FINES_CIENTIFICOS = 'F',
}

export enum EnumIdsTcTipoPuntoInspeccion {
    ID_AEROPUERTO = 1,
    ID_PUERTO = 2,
    ID_TERRESTRE = 3,
}
export enum EnumIdsTcFormatoSolicitud {
    ID_APLICACION = 1,
    ID_PAPEL = 2,
}
export enum EnumIdsTcTipoModulo {
    ID_IMPORTACION = 1,
    ID_EXPORTACION = 2,
    ID_CAMPANAS = 3,
    ID_CEXVEG_COMUNES = 4,
    ID_ATESTACIONES = 5,
    ID_CPE = 6,
    ID_PV = 7,
    ID_IMPRESOS_I_III = 9,
}

export enum EnumIdsTcEstadoSolicitud {
    ID_BORRADOR = 1,
    ID_NUEVA = 2,
    ID_FINALIZADA_CONFORME = 3,
    ID_RECHAZADA_INSPECTOR = 4,
    ID_EN_TRAMITE = 5,
    ID_ANULADA = 6,
    ID_PREVIA_ACEPTADA = 7,
    ID_PREVIA_PENDIENTE = 8,
    ID_REVISION_SOLICITANTE = 9,
    ID_PENDIENTE_TRACES = 10,
    ID_RECHAZADA_TRACES = 11,
    ID_PENDIENTE_ADUANAS = 12,
    ID_RECHAZADA_ADUANAS = 13,
    ID_REVISADO_SOLICITANTE = 14,
    ID_RECHAZADA_PARCIALMENTE = 15,
    ID_RECHAZADA_HIGIENE = 16,
}

export enum EnumIdsTcTipoMedioTransporte {
    ID_BARCO = 1,
    ID_AVION = 2,
    ID_VEHICULO = 3,
    ID_FERROCARRIL = 4,
}

export enum EnumIdsTcSubTipoSolicitud {
    ID_NORMAL = 1,
    ID_NORMAL_PREDUA = 2,
    ID_CANARIAS = 3,
    ID_CANARIAS_CF = 4,
    ID_CANARIAS_PREDUA = 5,
    ID_CANARIAS_PREDUA_CF = 6,
    ID_PROD_FITO_PREDUA = 7,
    ID_TRASLADO = 10,
    ID_TRASLADO_PREDUA = 11,
    ID_TRANSITO_DIRECTO = 12,
    ID_TRANSITO_DIRECTO_PREDUA = 13,
    ID_TRANSBORDO = 14,
    ID_TRANSBORDO_PREDUA = 15,
    ID_FINES_CIENTIFICOS = 16,
    ID_FINES_CIENTIFICOS_PREDUA = 17,
}

export enum EnumIdsTwTcTipoTransbordo {
    ID_A_TERCER_PAIS = 1,
    ID_A_PCF_UE = 2,
}

export enum EnumIdsTwTcDecisionInspeccion {
    ACEPTAR = 1,
    RECHAZAR = 2,
    NO_PROCEDE = 3,
    RECHAZAR_PARCIALMENTE = 4,
    NO_APTO_POR_HIGIENE = 5,
}

export enum EnumIdsTwTcDecisionInspeccionLetter {
    ACEPTAR = 'A',
    RECHAZAR = 'R',
    NO_PROCEDE = 'N',
    RECHAZAR_PARCIALMENTE = 'RP',
    NO_APTO_POR_HIGIENE = 'RH',
}

export enum EnumIdsTwTcMedidaRechazo {
    DESTRUCCION = 1,
    DENEGACION_ENTRADA = 2,
    CUARENTENA_IMPUESTA = 3,
    TRATAMIENTOS_APROPIADOS = 4,
    TRANSFORMACION_INDUSTRIAL = 5,
    REEXPEDICION = 6,
    OTROS = 7,
}

export enum EnumIdsTcNimf15 {
    ID_CUMPLE = 1,
    ID_NO_CUMPLE = 2,
    ID_NO_APLICA = 3,
}

export enum EnumIdsTwTcTipoClonacion {
    ID_CLONACION = 1,
    ID_PARTICION = 2,
    ID_ANULACION_SUSTITUCION = 3,
    ID_FINALIZA_TRASLADO = 4,
}

export enum EnumIdsTcTipoCantidadAtestFito {
    ID_PESO = 1,
    ID_VOLUMEN = 2,
    ID_UNIDADES = 3,
}

export enum EnumIdsTwTcResultadoEnvioMuestraLaboratorio {
    ID_PENDIENTE = 1,
    ID_ACEPTADA = 2,
    ID_RECHAZADA = 3,
}

/*export enum EnumIdsTwTcTipoTransito {
    ID_PARA_EL_TRANSBORDO = 1,
    ID_PARA_TRANSLADO_A = 2
}*/

export enum EnumIdsTcGrupo {
    ID_FILTRO_DE_PALETS = 15,
    ID_MAQUINARIA_AGRICOLA = 47,
    ID_PRODUCTOS_FITOSANITARIOS = 48,
}

export enum EnumCodigosTwTcAcciones {
    /*01*/ MANTENIMIENTOS = 'CCMA',
    /*02*/ USUARIOS_CEXVEG = 'CCUSCE',
    /*03*/ USUARIOS_EXTERNOS = 'CCUSEX',
    /*04*/ ESTADISTICAS = 'CCES',
    /*05*/ INFORMES_GENERALES = 'CCINGE',
    /*06*/ SOLICITUD = 'ISO',
    /*07*/ NUEVA_SOLICITUD = 'INUSO',
    ///*08*/EDITAR_SOLICITUD = "IEDSO",
    /*09*/ CLONACION_SOLICITUD = 'ICLSO',
    /*10*/ EXPORTACION_EXCEL = 'IEXEX',
    /*11*/ ELIMINAR_SOLICITUD = 'IELSO',
    /*12*/ ANULACION_SOLICITUD = 'IANSO',
    /*13*/ IMPRIMIR_DATOS_SOLICITUD = 'IIMDASO',
    /*14*/ IMPRIMIR_CF = 'IIMCF',
    /*15*/ GUARDAR_SOLICITUD = 'IGUSO',
    /*16*/ ENVIAR_SOLICITUD = 'IENSO',
    /*17*/ MENU_DATOS_BASICOS = 'IMEDABA',
    /*18*/ MENU_PRODUCTOS = 'IMEPR',
    /*19*/ MENU_TASAS = 'IMETA',
    /*20*/ MENU_DOCUMENTOS = 'IMEDO',
    /*21*/ MENU_INSPECCIONES = 'IMEIN',
    /*154*/ MENU_LABORATORIO = 'IMELAB',
    /*155*/ ENVIO_MUESTRAS_SOLICITUD = 'IENVLAB',
    /*157*/ GUARDAR_DOCUMENTOS_LABORATORIO = 'IDOCLAB',
    /*169*/ VER_PANTALLA_DOCUMENTO_LABORATORIO = 'IVDOCLAB',
    /*22*/ MENU_ANULACION = 'IMEAN',
    /*23*/ MENU_SEGUIMIENTO = 'IMESE',
    /*24*/ MENU_DATOS_PREDUA = 'IMEDAPR',
    /*25*/ MENU_PREVIA = 'IMEPRE',
    /*26*/ MENU_OTROS_DATOS = 'IMEOTDA',
    /*27*/ GUARDAR_INSPECCION = 'IGUIN',
    /*28*/ MENU_ENVIO = 'IMEEN',
    /*30*/ GUARDAR_DOCUMENTOS = 'IGUDO',
    /*31*/ REENVIAR_TRACES = 'IRETR',
    /*32*/ REENVIAR_ADUANAS = 'IREAD',
    /*33*/ IMPRIMIR_RESULTADO_INSPECCION = 'IIMREIN',
    /*34*/ IMPRIMIR_DOCUMENTO_TRANSPORTE = 'IIMDOTR',
    /*35*/ MISDATOS_USREXTERNO = 'MIDAUEX',
    /*36*/ MENU_PERMISOS_ACCIONES = 'CCMEPEAC',
    /*37*/ USUARIOS_MIGRACION = 'CCUSMIG',
    /*38*/ GUARDAR_EMBALAJES = 'IGUEM',

    /*39*/ SOLICITUD_EXPORTACION = 'ESO',
    /*40*/ NUEVA_SOLICITUD_EXPORTACION = 'ENUSO',
    /*41*/ CLONACION_SOLICITUD_EXPORTACION = 'ECLSO',
    /*42*/ EXPORTACION_EXCEL_EXPORTACION = 'EEXEX',
    /*43*/ ELIMINAR_SOLICITUD_EXPORTACION = 'EELSO',
    /*44*/ ANULACION_SOLICITUD_EXPORTACION = 'EANSO',
    /*45*/ IMPRIMIR_DATOS_SOLICITUD_EXPORTACION = 'EIMDASO',
    /*46*/ IMPRIMIR_CF_EXPORTACION = 'EIMCF',
    /*47*/ GUARDAR_SOLICITUD_EXPORTACION = 'EGUSO',
    /*48*/ ENVIAR_SOLICITUD_EXPORTACION = 'EENSO',
    /*49*/ MENU_DATOS_BASICOS_EXPORTACION = 'EMEDABA',
    /*50*/ MENU_PRODUCTOS_EXPORTACION = 'EMEPR',
    /*51*/ MENU_TASAS_EXPORTACION = 'EMETA',
    /*52*/ MENU_DOCUMENTOS_EXPORTACION = 'EMEDO',
    /*53*/ MENU_INSPECCIONES_EXPORTACION = 'EMEIN',
    /*158*/ MENU_LABORATORIO_EXPORTACION = 'EMELAB',
    /*159*/ ENVIO_MUESTRAS_SOLICITUD_EXPORTACION = 'EENVLAB',
    /*161*/ GUARDAR_DOCUMENTOS_LABORATORIO_EXPORTACION = 'EDOCLAB',
    /*170*/ VER_PANTALLA_DOCUMENTO_LABORATORIO_EXPORTACION = 'EVDOCLAB',
    /*54*/ MENU_ANULACION_EXPORTACION = 'EMEAN',
    /*55*/ MENU_SEGUIMIENTO_EXPORTACION = 'EMESE',
    /*59*/ GUARDAR_INSPECCION_EXPORTACION = 'EGUIN',
    /*60*/ MENU_ENVIO_EXPORTACION = 'EMEEN',
    /*61*/ GUARDAR_DOCUMENTOS_EXPORTACION = 'EGUDO',
    /*64*/ IMPRIMIR_RESULTADO_INSPECCION_EXPORTACION = 'EIMREIN',
    /*66*/ MENU_DECLSUPLEMENTARIA_EXPORTACION = 'EMEDESU',
    /*67*/ GUARDAR_EMBALAJES_EXPORTACION = 'EGUEM',
    /*68*/ MENU_PREVIA_EXPORTACION = 'EMEPRE',
    /*69*/ GUARDAR_DECL_SUPL = 'EGUDS',
    /*70*/ REENVIAR_TRACES_ADUANAS_WS = 'IRETRAWS',
    /*71*/ MENU_REEXPORTACION = 'EMERE',
    /*72*/ MENU_ALEGACIONES = 'EMEAL',
    /*73*/ GUARDAR_DOCUMENTOS_ALEGACIONES = 'EGUDA',
    /*74*/ EMISION_EPHYTO = 'EEMEP',

    /*76*/ MENU_AGENTES_CONTROL = 'CCMEAC',
    /*77*/ GUARDAR_AGENTE_CONTROL = 'CCGUAC',

    /*78*/ SOLICITUD_ATESTACION = 'ASO',
    /*79*/ NUEVA_SOLICITUD_ATESTACION = 'ANUSO',
    /*80*/ EXPORTACION_EXCEL_ATESTACION = 'AEXEX',
    /*81*/ ELIMINAR_SOLICITUD_ATESTACION = 'AELSO',
    /*82*/ GUARDAR_SOLICITUD_ATESTACION = 'AGUSO',
    /*83*/ MENU_DATOS_BASICOS_ATESTACION = 'AMEDABA',
    /*84*/ MENU_PRODUCTOS_ATESTACION = 'AMEPR',
    /*85*/ MENU_DOCUMENTOS_ATESTACION = 'AMEDO',
    /*86*/ MENU_RESUMEN_ATESTACION = 'AMERE',
    /*87*/ GUARDAR_DOCUMENTOS_ATESTACION = 'AGUDO',
    /*88*/ MENU_ENVIO_ATESTACION = 'AMEEN',
    /*89*/ MENU_TEXTO_ATESTACION = 'AMETE',
    /*90*/ MENU_LUGAR_PRODUCCION_ATESTACION = 'AMELU',
    /*91*/ GUARDAR_TEXTO_ATESTACION = 'AGUTE',
    /*92*/ ENVIAR_SOLICITUD_ATESTACION = 'AENSO',
    /*93*/ MENU_RESULTADO_ATESTACION = 'AMERES',
    /*94*/ COMPROBAR_EPHYTOS = 'ECOEPH',
    /*95*/ DESCARGAR_CF = 'EDCF',
    /*96*/ ANULAR_SOLO_CF = 'EANSCF',
    /*97*/ DESCARGA_EPHYTO = 'EDEPH',
    /*98*/ ANULAR_EPHYTO = 'EANEPH',
    /*100*/ NUEVO_NUM_SEGURIDAD = 'ENUNSEG',
    /*101*/ NUEVA_BORRAR_COPIA_CF = 'ENUCO',
    /*102*/ GUARDAR_COPIA_CF = 'EGUCO',
    /*103*/ MENU_ANULACION_ATESTACION = 'AMEAN',
    /*104*/ MENU_RELACION_ATESTACIONES_EXPORTACION = 'EMEAT',
    /*105*/ IMPRIMIR_COPIA_CF = 'EIMCO',

    /*106*/ SOLICITUD_CPE = 'CPESO',
    /*107*/ NUEVA_SOLICITUD_CPE = 'CPENUSO',
    /*108*/ EXPORTACION_EXCEL_CPE = 'CPEEXEX',
    /*109*/ ELIMINAR_SOLICITUD_CPE = 'CPEELSO',
    /*110*/ GUARDAR_SOLICITUD_CPE = 'CPEGUSO',
    /*111*/ MENU_DATOS_BASICOS_CPE = 'CPEMEDABA',
    /*112*/ MENU_PRODUCTOS_CPE = 'CPEMEPR',
    /*113*/ MENU_DOCUMENTOS_CPE = 'CPEMEDO',
    /*114*/ GUARDAR_DOCUMENTOS_CPE = 'CPEGUDO',
    /*115*/ MENU_ENVIO_CPE = 'CPEMEEN',
    /*116*/ MENU_LUGAR_PRODUCCION_CPE = 'CPEMELU',
    /*117*/ ENVIAR_SOLICITUD_CPE = 'CPEENSO',
    /*118*/ MENU_ANULACION_CPE = 'CPEMEAN',
    /*119*/ MENU_CERTIFICACION_CPE = 'CPEMECE',
    /*120*/ MENU_REGLAS_CORREO = 'CCCORREO',

    // Campañas, cultivos, recintos, periodos

    /*131*/ MENU_RECINTO_CAMPANIA = 'CMER',
    /*132*/ MENU_CULTIVO_CAMPANIA = 'CMEC',
    /*133*/ MENU_CAMPANIA_GENERAL = 'CMGEN',
    /*134*/ PERIODOS = 'CCPE',
    /*135*/ NUEVO_PERIODO = 'CCNUPE',
    /*136*/ MENU_DATOS_BASICOS_PERIODO = 'CCMEDABAPE',
    /*137*/ MENU_DATOS_CA_Y_ENTIDADES = 'CCMECAEN',
    /*138*/ CLONACION_PERIODO = 'CCCLPE',
    /*233*/ ELIMINAR_CULTIVO_RECINTO = 'CECURE',
    /*245*/ BAJA_CULTIVO_RECINTO = 'CBACU',

    // Solicitudes de campaña, recintos "PIAEd", documentos, pantalla Envío.
    /*139*/ MENU_SOL_CAM = 'CMSOL',
    /*140*/ MENU_DATOS_BAS_SOL_CAM = 'CMDBSOL',
    /*141*/ MENU_REC_PIA_SOL_CAM = 'CMRECSOL',
    /*142*/ MENU_DOC_SOL_CAM = 'CMDOCSOL',
    /*143*/ MENU_SEND_SOL_CAM = 'CMENVSOL',
    /*144*/ NEW_SOL_CAM = 'CNSOL',
    /*145*/ EXCEL_SOLES_CAM = 'CEXSOL',
    /*146*/ REMOVE_SOL_CAM = 'CESOL',
    /*153*/ SAVE_DATOS_BASICOS_SOL_CAM = 'CGDBSOL',
    /*148*/ ADD_DOC_SOL_CAM = 'CADOCSOL',
    /*149*/ REMOVE_DOC_SOL_CAM = 'CEDOCSOL',
    /*150*/ SEND_SOL_CAM = 'CENVSOL',
    /*151*/ ADD_REC_A_SOL_CAM = 'CARECSOL',
    /*152*/ REMOVE_REC_DE_SOL_CAM = 'CERECSOL',
    /*773*/ AUTORIZAR_CULTIVO_CAM = 'CACU',

    /*162*/ MENU_DATOS_BASICOS_PROGRAMA_VERIFICACION = 'PVMEDABA',
    /*167*/ PROGRAMAS_VERIFICACION = 'PVBUSCADOR',
    /*171*/ ADMISION_PV = 'PVADMISION',

    // Validación y aceptación de Solicitudes de Campaña
    /*163*/ VALIDATE_SOL_CAM = 'CVALSOL',
    /*164*/ ACCEPT_SOL_CAM = 'CACEPSOL',
    /*165*/ MENU_VAL_ACCEPT_SOL_CAM = 'CMEVALSOL', // Validación y aceptación
    /*168*/ UPDATE_DOC_SOL_CAM = 'CUDOCSOL',

    // Unidades de inspección (U.I.)

    /*173*/ MENU_UDS_INSPECCION = 'MUI',
    /*174*/ MENU_DATOS_BAS_UD_INSPECCION = 'CMDBUI',
    /*174*/ NUEVA_UD_INSPECCION = 'CNUI',
    /*175*/ EXPORT_UDS_INSPECCION = 'CEXUI',
    /*176*/ ADD_RECINTO_UD_INSPECCION = 'CARECUI',
    /*177*/ REMOVE_RECINTO_UD_INSPECCION = 'CERECUI',
    /*178*/ EDIT_UD_INSPECCION = 'CEDITUI',
    /*179*/ VIEW_UD_INSPECCION = 'CVERUI',
    /*181*/ REMOVE_UD_INSPECCION = 'CRUI',

    // Inspecciones de U.I.
    /*187*/ SUSPENDER_UD_INSPECCION = 'CSUI',
    /*188*/ BAJA_UD_INSPECCION = 'CBAIUI',
    /*189*/ MENU_INSPECCIONES_UI = 'CMLIUI',
    /*190*/ MENU_COMENTARIOS_UI = 'CMCUI',
    /*191*/ MENU_DOCUMENTOS_UI = 'CMDUI',
    /*192*/ ADD_INSPECCION_UI = 'CNIUI',
    /*193*/ EDIT_INSPECCION_UI = 'CEIUI',
    /*194*/ CONS_INSPECCION_UI = 'CCIUI',
    /*195*/ REMOVE_INSPECCION_UI = 'CDELIUI',
    /*196*/ VALID_NO_VALID_INSPECCION_UI = 'CVIUI',
    /*197*/ ADD_DOC_UI = 'CNDUI',
    /*198*/ CONS_DOC_UI = 'CCDUI',
    /*199*/ REMOVE_DOC_UI = 'CEDUI',
    /*200*/ ADD_COMENTARIO_UI = 'CNCUI',
    /*201*/ CONS_COMENTARIO_UI = 'CCCUI',
    /*202*/ REMOVE_COMENTARIO_UI = 'CECUI',

    // Aforos y Cortes de UI
    /*219*/ MENU_AFOROS_Y_CORTES_UI = 'CMACUI',
    /*220*/ ADD_AFORO_CULTIVO_UI = 'CAAFCU',
    /*221*/ CONS_AFORO_CULTIVO_UI = 'CCAFCU',
    /*222*/ REMOVE_AFORO_CULTIVO_UI = 'CEAFCU',
    /*234*/ UPDATE_AFORO_CULTIVO_UI = 'CMAFCU',

    /*235*/ ADD_CORTE_UI = 'CACOCUUI',
    /*236*/ CONS_CORTE_UI = 'CCCOCUUI',
    /*237*/ REMOVE_CORTE_UI = 'CECOCUUI',
    /*238*/ UPDATE_CORTE_UI = 'CMCOCUUI',

    // Certificados Fitosanitarios
    /*172*/ BUSCADOR_CFS = 'BUSCCFS',

    // Migración de documentación a filesystem
    /*184*/ MIGRACION_FILESYSTEM = 'MDF',

    // Rechazo Parcial (Division Solicitudes)
    /*183*/ VER_RECHAZO_PARCIAL = 'IVREPA',

    /*185*/ RADIOBUTTON_RECHAZO_PARCIAL = 'IRBREPA',
    /*223*/ RADIOBUTTON_NO_APTO_POR_HIGIENE = 'IRBREHI',

    // Buscador de Rechazos de TRACES
    /*182*/ MENU_RECHAZOS_TRACES = 'IMERETR',
    /*186*/ MENU_TITULO_IMPORTACION_ADMIN = 'ITIMADMIN',

    // Buscador de Traslados de TRACES
    /*244*/ MENU_TRASLADOS_TRACES = 'IMETRTR',

    /*224*/ FINALIZAR_TRASLADOS = 'IFINTRAS',

    // Mantenimiento Permisos - Acciones Impresos I y III
    /*228*/ NUEVO_IMPRESO_I = 'NUIMPI',
    /*229*/ ELIMINAR_IMPRESO_I = 'ELIMPI',
    /*230*/ NUEVO_IMPRESO_III = 'NUIMPIII',
    /*231*/ ELIMINAR_IMPRESO_III = 'ELIMPIII',

    /*232*/ ANULAR_SOLICITUD_CAMPANIA = 'CANU',
    /*239*/ MENU_IMPORTADOR_LUGAR_DESTINO = 'IMEIMLUDE',

    // Mantenimiento de Aforos
    /*240*/ MENU_AFOROS = 'CMAFME',

    /*248*/ REASIGNACION_MANUAL = 'REASIGMAN',
}

export enum EnumIdsTcPerfilUsuario {
    ID_SOLICITANTE = 1,
    ID_INSPECTOR = 2,
    ID_ADMINISTRADOR = 3,
    ID_COORDINADOR = 4,
    ID_MAPA = 5,
    ID_OPERADOR_CAMPANIAS_ESPECIFICAS = 6,
    ID_LABORATORIO = 7,
    ID_ENTIDAD_AUDITORA = 9,
    ID_COMUNIDAD_AUTONOMA = 10,
    ID_CONSULTAS = 11,
    ID_GRABADOR = 12,
    ID_AGENTE_CONTROL = 16,
}

//#endregion

export class AccessSolicitudViewModel {
    public IdEstadoSolicitud: number;
    public IdTipoSolicitud: number;
    public IdSubTipoSolicitud: number | null;
}

export class AccessSolicitudExViewModel {
    public IdEstadoSolicitudEx: number;
    public IdTipoSolicitudEx: number;
}

export class AccessSolicitudAtestViewModel {
    public IdEstadoSolicitudAtest: number;
    public IdTipoSolicitudAtest: number;
}

export class AccessSolicitudCpeViewModel {
    public IdEstadoSolicitudCpe: number;
}

export enum EnumIdsTcEnvioAduanas {
    ID_NO_ENVIADO = 1,
    ID_ENVIADO = 2,
    ID_PENDIENTE = 3,
    ID_RECHAZADO = 4,
    ID_ERROR_ENVIOS = 5,
}

export enum EnumIdsTipoOperacionEnvioAduanas {
    VALIDACION = 'VAL',
    ENVIO = 'ALT',
}

export enum EnumIdsTipoOperacionEnvioTraces {
    VALIDATION = 'VAL',
    SUBMIT = 'ALT',
}
export enum EnumTipoExentoCertificacionCpe {
    CHECK_EXENTO_A = 'A',
    CHECK_EXENTO_B = 'B',
    CHECK_EXENTO_C = 'C',
    CHECK_EXENTO_D = 'D',
    CHECK_EXENTO_E = 'E',
    CHECK_EXENTO_F = 'F',
    CHECK_EXENTO_G = 'G',
}

export enum EnumIdsEstadoChedPP {
    ID_PENDIENTE = 1,
    ID_FINALIZADO_CONFORME = 2,
    ID_RECHAZADO = 3,
    ID_ANULADO = 4,
    ID_NO_PROCEDE = 5,
}

export enum EnumIdsTcSeccionSeguimiento {
    ID_DATOS_BASICOS = 1,
    ID_PRODUCTOS = 2,
    ID_TASAS = 3,
    ID_DOCUMENTACION = 4,
    ID_INSPECCIONES = 5,
    ID_LABORATORIOS = 6,
    ID_OTROS = 7,
}

export enum EnumIdsTwTcConfiguracionImportadorYlugarDestinoPorSolicitud {
    ID_HIGIENE_NOCHEDPP_NOCANARIAS_IMPNACIONAL = 1,
    ID_HIGIENE_NOCHEDPP_NOCANARIAS_IMPEXTRANJERO = 2,
    ID_NOHIGIENE_CHEDPP_NOCANARIAS_IMPNACIONAL = 3,
    ID_NOHIGIENE_CHEDPP_NOCANARIAS_IMPEXTRANJERO = 4,
    ID_HIGIENE_CHEDPP_NOCANARIAS_IMPNACIONAL = 5,
    ID_HIGIENE_CHEDPP_NOCANARIAS_IMPEXTRANJERO = 6,
    ID_NOHIGIENE_NOCHEDPP_CANARIAS_IMPNACIONAL = 7,
    ID_NOHIGIENE_NOCHEDPP_CANARIAS_IMPEXTRANJERO = 8,
    ID_HIGIENE_NOCHEDPP_CANARIAS_IMPNACIONAL = 9,
    ID_HIGIENE_NOCHEDPP_CANARIAS_IMPEXTRANJERO = 10,
}

export enum EnumIdsTcProvincia {
    ID_LAS_PALMAS = 35,
    ID_TENERIFE = 38,
    ID_CEUTA = 51,
    ID_MELILLA = 52,
}
